import React from "react";
import { Box, Card, Stack, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import StatusComponent from "../../../stories/StatusComponent/StatusComponent";
import { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import BaseURL from "../../../utils/base-uri.json";
import axios from "../../../utils/fvAxios";
import Nodata from "../../../pages/Nodata/Nodata";

import TextareaAutosize from "@mui/material/TextareaAutosize";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Grid } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
// import FormControl from '@mui/material/FormControl';
import Select from "@mui/material/Select";

import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";

import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import fileDownload from "js-file-download";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import { getOrgType, getstatuses } from "../../../utils/Token";

import { TextField } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&:before": {
    display: "none",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.action.hover,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
    marginBottom: "20px",
  },
}));

export default function ({
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  VIEWMODE,
  setHasLocationData,
  PQCLIENTID,
  PqStatusID,
  PqClientName,
  IsMultiple
}) {
  const params = new URLSearchParams(window.location.search);
  const PQID = params?.get("pqid");
  const [response, setResponse] = useState([]);
  const [refresh, setRefresh] = React.useState(true);
  const [loading, setLoading] = useState(false);
  // const { reset } = useForm();

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(
        BaseURL.baseUrl +
        "Prequalification/SectionOrSubSectionDetails?pqId=" +
        PQID +
        "&sectionId=" +
        Secid +
        "&subSectionTypeCondition=" +
        SubSectionTypeCondition +
        "&sectionType=" +
        SectionType +
        "&subSectionId=" +
        SubId
      )
      .then((resp) => {
        setResponse(resp?.data?.data);
        setLoading(false);
        if (resp?.data?.data?.length > 0) {
          setHasLocationData(true);
        } else {
          setHasLocationData(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }, [refresh]);

  const formats = [
    "strike",
    "size",
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'background',
    'list',
    'align',
    // 'link',
    'image',
    'color',
    'indent',
    'clean',
    'blockquote', 'script'

  ];

  const modules = {
    toolbar: [
      ['undo', 'redo'],
      [{ 'size': [] }],
      [{ 'font': [] }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      // ['link'],
      ['clean'],

      [{ 'color': [] }, { 'background': [] }],
      [{ 'align': [] }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
    ],
  };
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme?.breakpoints?.down("md"));
  const handleUndo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.undo();
  };

  const handleRedo = () => {
    const quill = quillRef.current.getEditor();
    quill.history.redo();
  };
  const quillRef = React.createRef();

  const [StatusList, setStatusList] = useState([]);
  const [StatusId, setStatusId] = useState("");
  const [To, setTo] = useState("");
  const [ToError, setToError] = useState("");
  const [Cc, setCc] = useState("");
  const [CcError, setCcError] = useState("");

  const [Subject, setSubject] = useState("");
  const [Body, setBody] = useState("");
  const [PrequalificationSiteId, setPrequalificationSiteId] = useState("");
  const [Dis, setDis] = useState(false);


  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const handleClickOpen = (r) => {
    setStatusList(getstatuses()?.filter((r) => r?.prequalificationStatusId == 13 || r?.prequalificationStatusId == 8 || r?.prequalificationStatusId == 26));
    setStatusId(getstatuses()?.filter((r) => r?.prequalificationStatusId == 13 || r?.prequalificationStatusId == 8 || r?.prequalificationStatusId == 26)[0]?.prequalificationStatusId);
    axios
      .get("Client/AssignLocationStatus?SubsectionId=" + SubId + "&pqSiteId=" + r?.prequalificationSitesId + "&pqSiteClientId=" + r?.clientId + "&pqId=" + PQID)
      .then((res) => {
        setTo(res?.data?.data?.sendTo == null ? "" : res?.data?.data?.sendTo);
        setCc(res?.data?.data?.sendCC == null ? "" : res?.data?.data?.sendCC);
        setSubject(res?.data?.data?.subject == null ? "" : res?.data?.data?.subject);
        setBody(res?.data?.data?.body == null ? "" : res?.data?.data?.body);
        setPrequalificationSiteId(res?.data?.data?.prequalificationSiteId);
      })
      .catch((err) => {
        console.log(err);
      });
    setOpen(true);
  };

  const ChangeTo = (e) => {
    let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
    let result = e?.target?.value?.split(",");
    result?.forEach((em) => {
      if (regex?.test(em) == true) {
        setToError("");
        setTo(e?.target?.value);
      } else if (em == "") {
        setToError("");
        setTo(e?.target?.value);
      } else {
        setToError("Please check To email");
        setTo(e?.target?.value);
      }

    });

  }
  const ChangeCc = (e) => {
    let regex = new RegExp(/^[ ]*([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})[ ]*$/i);
    let result = e?.target?.value?.split(",");
    result?.forEach((em) => {
      if (regex?.test(em) == true) {
        setCcError("");
        setCc(e?.target?.value);
      } else if (em == "") {
        setCcError("");
        setCc(e?.target?.value);
      } else {
        setCcError("Please check CC email");
        setCc(e?.target?.value);
      }

    });

  }


  const SendMail = () => {
    if (StatusId != "" && To != "" && Cc != "" && Subject != "" && Body != "" && ToError == "" && CcError == "") {
      setDis(true);
      const data = {
        "prequalificationSiteId": PrequalificationSiteId,
        "prequalificationStatusId": StatusId,
        "subsectionId": SubId,
        "sendTo": To,
        "sendCC": Cc,
        "subject": Subject,
        "body": Body
      }
      axios
        .post("Client/AssignLocationStatus", data)
        .then((res) => {
          if (res?.data?.responseCode == 100) {
            toastNotify(res?.data?.responseMessage, true);
            setDis(false);
            setRefresh(!refresh);
            handleClose();
          } else {
            setDis(false);
            toastNotify(res?.data?.responseMessage, false);
          }
        })
        .catch((err) => {
          console.log(err);
          setDis(false);
        });
    } else {
      toastNotify("Please enter mandatory fields", false);
      setDis(false);
    }

  };


  const handleClose = () => {
    setOpen(false);
  };
  const Open = () => {
    setOpen(true);
  };

  const groupedData = response?.reduce((acc, curr) => {
    const clientKey = curr?.clientName;
    const buKey = curr?.businessUnitName;
    if (!acc[clientKey]) {
      acc[clientKey] = {};
    }
    if (!acc[clientKey][buKey]) {
      acc[clientKey][buKey] = [];
    }
    acc[clientKey][buKey]?.push(curr);
    return acc;
  }, {});

  const [expanded, setExpanded] = React.useState(false);
  const ChangeExpanded = () => {
    setExpanded(expanded);
  };

  return (
    <Card sx={{ backgroundColor: "#fff" }}>
      <ToastContainer />
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <span style={{ fontSize: "larger" }}>
              Assign Location Status
            </span>
            <br></br>
          </DialogTitle>
          <div className="">
            <div>
              <span style={{ color: "#3E4A62" }}>
                Assign Status:
                <small style={{ color: "red" }}>*</small>
              </span>
              <br />
              <Select
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "350px",
                }}
                labelId="demo-multiple-name-label"
                id="demo-multiple-name"
                size="small"
                value={StatusId || ""}
                onChange={(e) => setStatusId(e.target.value)}
                MenuProps={MenuProps}
              >
                {StatusList?.map((item, index) => (
                  <MenuItem key={index} title={item?.prequalificationStatusId} value={item?.prequalificationStatusId}>
                    {item?.prequalificationStatus}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="mt-2">
              <span style={{ color: "#3E4A62" }}>
                Send Notification To<small style={{ color: "red" }}>*</small>
              </span>
              <br />
              <TextField type='text'
                value={To || ""}
                onChange={(e) => {
                  ChangeTo(e);
                }}
                size='small'
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "350px",
                }} />
            </div>
            <span style={{ color: "red" }}>{ToError}</span>

            <div className="mt-2">
              <span style={{ color: "#3E4A62" }}>
                Send Notification CC:<small style={{ color: "red" }}>*</small>
              </span>
              <br />
              <TextField type='text'
                value={Cc || ""}
                onChange={(e) => {
                  ChangeCc(e);
                }}
                size='small'
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "350px",
                }} />
            </div>
            <span style={{ color: "red" }}>{CcError}</span>

            <div className="mt-2">
              <span style={{ color: "#3E4A62" }}>
                Subject:<small style={{ color: "red" }}>*</small>
              </span>
              <br />
              <TextField type='text'
                value={Subject || ""}
                onChange={(e) => {
                  setSubject(e.target.value);
                }}
                size='small'
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                  width: "350px",
                }} />
            </div>

            <div className="mt-2" style={{ width: "500px" }}>
              <span style={{ color: "#3E4A62" }}>
                Body:<small style={{ color: "red" }}>*</small>
              </span>
              <IconButton onClick={handleUndo} sx={{ marginBottom: "-64px", marginRight: "-90px" }}>
                <UndoIcon />
              </IconButton>
              <IconButton onClick={handleRedo} sx={{ marginBottom: "-64px" }}>
                <RedoIcon />
              </IconButton>

              <ReactQuill
                ref={quillRef}
                theme="snow"
                modules={modules}
                formats={formats}
                value={Body}
                onChange={setBody}
              />
            </div>

          </div>

          <DialogActions>
            <div className="login-help__buttonContainer mt-4">
              <Button
                variant="contained"
                className="login-help-button-cancel mx-2"
                onClick={() => {
                  handleClose();
                  setDis(false);
                  setCcError("");
                  setToError("");
                }}
              >
                Cancel
              </Button>
              <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={Dis}
              >
                <CircularProgress color="inherit" />
              </Backdrop>
              <Button
                variant="contained"
                className="login-button-request mx-2"
                disabled={Dis}
                onClick={SendMail}
              >
                Send
              </Button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      {response?.length > 0 ? (
        Object.entries(groupedData)?.map(([clientName, clientData]) => (
          <>
            <div key={clientName}>
              <Accordion onChange={ChangeExpanded} sx={{ marginTop: "10px" }}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  sx={{ backgroundColor: "#F2F4F7" }}
                >
                  <Typography
                    sx={{
                      flexShrink: 0,
                      fontSize: "600",
                      color: "#667085",
                      marginBottom: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {" "}
                    {clientName == "null" ? "Global Locations" : clientName}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0px" }}>
                  <Box sx={{ backgroundColor: "#f8f9fa" }}>
                    <TableContainer
                      component={Paper}
                      key={"ss" + clientName}
                      sx={{ borderBottom: 0 }}
                    >
                      <Table aria-label="customized table">
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell>&nbsp; </StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell>&nbsp;</StyledTableCell>
                          </TableRow>
                        </TableHead>

                        {Object.entries(clientData)?.map(([buName, buData]) => (
                          <>
                            <TableHead key={buName}>
                              <TableRow>
                                <StyledTableCell>{buName}</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                                <StyledTableCell>&nbsp;</StyledTableCell>
                              </TableRow>
                            </TableHead>

                            <TableBody>
                              {buData?.map((r, index) => (
                                <TableRow key={index}>
                                  <StyledTableCell sx={{ width: "34%" }}>
                                    {" "}
                                    {r?.businesUnitsiteName}{" "}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ width: "32%" }}>
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ width: "30%" }}>
                                    <StatusComponent type={r?.pqSiteStatus} />
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    <IconButton
                                      aria-label="edit"
                                      onClick={() => handleClickOpen(r)}
                                      hidden={r?.pqSiteStatus != 16}
                                    >
                                      <img
                                        src={Edit}
                                        alt="editicon"
                                        style={{ width: "25px" }}
                                      />
                                    </IconButton>
                                  </StyledTableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </>
                        ))}
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </div>
          </>
        ))
      ) : loading ? (
        <LoadingSpinner />
      ) : (
        <Nodata />
      )}

      {/* <div className="mt-5">
        <span className="text-danger mx-3 mt-5" style={{ fontWeight: "bold" }}>
          IMPORTANT NOTICE
          <br />
          <span className="mx-3 mt-5">  All contractor employees must complete the {PqClientName} safety orientation and pass a quiz before being allowed to work onsite.</span> <br />
          <span className="mx-3 mt-2">  Specific information can be found in the Prequalification Requirements section.</span>
        </span>
      </div> */}
    </Card>
  );
}
